import { App } from 'antd';
import { useMutation } from '@tanstack/react-query';
import type { AxiosCustomError } from 'services/http';
import { http } from 'services/http';
import type { DocumentSignedUrlRes } from 'api/swagger';

interface IDownloadDocumentVariables {
  documentId: number;
}

export const useGetCargoDocumentLink = () => {
  const { message } = App.useApp();

  return useMutation<DocumentSignedUrlRes, unknown, IDownloadDocumentVariables>({
    mutationFn: async (variables) => {
      const { documentId } = variables;

      const res = await http.get<DocumentSignedUrlRes>(`client-office/v1/documents/${documentId}/link`);
      return res.data;
    },
    onError: (error) => {
      const { message: errorMessage, key } = (error as AxiosCustomError)?.response?.data || {};
      message.error(errorMessage || key);
    },
  });
};
